import { render, staticRenderFns } from "./note.vue?vue&type=template&id=2947ba36&scoped=true"
import script from "./note.vue?vue&type=script&lang=js"
export * from "./note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2947ba36",
  null
  
)

export default component.exports